var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHmArc2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 186.238,
    height: 228.943,
    viewBox: "0 0 186.238 228.943",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 2110",
    d: "M169.102 228.943C182.436 202.747 188.172 173.343 185.663 144.056C183.154 114.769 172.5 86.7686 154.904 63.2222C137.309 39.6758 113.476 21.5231 86.1009 10.8175C58.7256 0.111933 28.9007 -2.7193 -5.14472e-06 2.6441L0.47939 5.22732C28.898 -0.0466026 58.2254 2.7374 85.144 13.2644C112.063 23.7914 135.498 41.6413 152.8 64.7949C170.101 87.9485 180.578 115.482 183.046 144.28C185.513 173.078 179.872 201.993 166.761 227.752L169.102 228.943Z",
    fill: "#FFE743"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmArc2);
export default __webpack_public_path__ + "static/media/hmArc2.2983509e2cf81c405c52634d073f3b94.svg";
export { ForwardRef as ReactComponent };